module.exports = __webpack_public_path__ + "static/media/dealer_button_portrait.c2489991.png";